<template>
  <div class="DHWSystemWrap">
    <div class="center ashComWrap">
      <div class="comTitle">
        <h4>生活热水系统</h4>
        <div>
          <span>更新时间:</span>
          <span style="margin-left: 5px">{{ updateTime }}</span>
          <el-button
            type="primary"
            round
            size="mini"
            style="margin: 0 10px"
            :loading="loadingCenterData"
            @click="getCenterPanelData(centerTabsId)"
            >刷新</el-button
          >
        </div>
      </div>
      <div
        class="comContentBox center-content"
        v-loading="loadingCC"
        element-loading-background="rgba(255, 255, 255, 0.95)"
      >
        <el-tabs
          v-if="centerTabs.length"
          v-model="centerTabsValue"
          type="card"
          @tab-click="changeCenter"
        >
          <el-tab-pane
            v-for="(item, index) in centerTabs"
            :key="`${item?.id}-${index}`"
            :label="item.name"
            :name="item.name"
            lazy
          >
            <CenterPanel
              :dataGather="centerPanelData"
              :assetId="item?.id"
              :energyType="item?.energyType"
            />
          </el-tab-pane>
        </el-tabs>
        <el-empty
          v-else
          class="empty"
          :image-size="250"
          description="暂无数据"
        ></el-empty>
      </div>
    </div>
    <div class="bottom">
      <div>
        <TableWithJump
          titleName="生活热水系统报警"
          :listData="alarmListData"
          :tableData="alarmTableData"
          :tableDataHead="alarmTableHead"
          jumpUrl="/alarmManagement"
        />
      </div>
      <div>
        <TableWithJump
          titleName="生活热水系统工单"
          :listData="workListData"
          :tableData="workTableData"
          :tableDataHead="workTableHead"
          jumpUrl="/worksheets"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TableWithJump from "@/components/TableWithJump/TableWithJump";
import HeadTips from "@/components/HeadTips/HeadTips";
import CenterPanel from "@/components/zixitong/DHWSystem/system/CenterPanel";
import api from "@/api";
import {
  dateFtt,
  matchingAlarmLevel,
  matchingOrderLevel,
  formatTime,
  getProjectVal,
  matchingStatus,
  dealNumWith,
  matchingFireStatus,
} from "@/assets/js/utils";
import {
  DEFAULTCOOLINGTOWERCONTENT,
  DEFAULTWATERTOOLSCONTENT,
} from "@/assets/js/const";

export default {
  components: { TableWithJump, HeadTips, CenterPanel },
  data() {
    return {
      //中部生活热水系统
      loadingCenterData: false,
      updateTime: dateFtt("yyyy-MM-dd hh:mm:ss", new Date()),
      centerTabsValue: "",
      centerTabsEnergyType: "ac",
      centerTabsId: null,
      centerTabs: [],
      centerPanelData: {
        //保温水箱
        waterTank: {
          contentSwitch: [],
        },
        //环境监测
        envMonitorData: [],
        //主机能效
        hostEnergyData: {
          topNode: [],
          bottomNode: [],
        },
        //锅炉机组
        obtainBoilerList: {
          title: [],
          contentSwitch: [],
        },
        //热水循环泵
        warmWater: {
          title: [],
          contentSwitch: [],
        },
        //锅炉能效/热泵能效
        boilerEnergyData: {
          topNode: [],
          bottomNode: [],
        },
      },
      //报警
      alarmListData: [],
      alarmTableData: [],
      alarmTableHead: [
        { label: "ID", prop: "alarmId" },
        { label: "报警时间", prop: "time" },
        { label: "设备名称", prop: "deviceName" },
        { label: "设备/区域地址", prop: "location" },
        { label: "处理状态", prop: "confirm" },
        { label: "报警级别", prop: "level" },
      ],
      //工单
      workListData: [],
      workTableData: [],
      workTableHead: [
        { label: "工单ID", prop: "id" },
        { label: "工单名称", prop: "description" },
        { label: "工单级别", prop: "priority" },
        { label: "地点", prop: "location" },
        { label: "处理人", prop: "handlers" },
        { label: "处理时长", prop: "time" },
      ],
      loadingTLC: false,
      loadingTRC: false,
      loadingCC: false,
    };
  },
  methods: {
    async getAlarmsList() {
      let res = await api.lightingOSGetAlarms({
        projectId: getProjectVal("Id"),
        deviceType: "生活热水系统",
        pageSize: 5,
        page: 0,
      });
      if (res && res.data.code == 200) {
        this.alarmListData = Array.from(res.data.data.statistics).map(
          (item) => ({
            name: item.name == "total" ? "全部" : matchingAlarmLevel(item.name),
            value: item.value,
          })
        );
        this.alarmTableData = res.data.data.page.data;
        this.alarmTableData.map((v) => {
          v.time = v.endTime
            ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.endTime))
            : "";
          v.confirm = v.confirm ? "已确认" : "未确认";
          v.level = matchingAlarmLevel(v.level);
        });
      }
    },
    async getWorkOrderList() {
      let res = await api.lightingOSGetWorkOrder({
        projectId: getProjectVal("Id"),
        deviceType: "生活热水系统",
        pageSize: 5,
        page: 0,
      });
      if (res && res.data.code == 200) {
        this.workListData = Array.from(res.data.data.statistics).map(
          (item) => ({
            name: item.name == "total" ? "全部" : matchingOrderLevel(item.name),
            value: item.value,
          })
        );
        this.workTableData = res.data.data.page.data;
        this.workTableData.map((v) => {
          v.priority = matchingOrderLevel(v.priority);
          v.time = v.ts ? formatTime(v.ts) : "";
          v.handlers = v.assignStaffNames.join("、");
        });
      }
      // console.log(res);
    },
    dealNameWithAll(data = []) {
      const objAll = {
        nameTotal: "全部",
        valueTotal: 0,
        name: "末端开启",
        value: 0,
        rateFlag: true,
      };
      const newData = data.filter((item) => {
        if (item.name == "末端开启") {
          objAll.value = item.value;
          return false;
        } else if (item.name == "全部") {
          objAll.valueTotal = item.value;
          return false;
        }
        return true;
      });
      return {
        newData,
        objAll,
      };
    },
    //获取生活热水列表
    async getDomesticHotHaterList() {
      let res = await api.DHWGetDomesticHotHaterList({
        projectId: getProjectVal("Id"),
        deviceType: "锅炉,空气源热泵",
      });
      if (res && res.data.code == 200) {
        this.centerTabs = res.data.data.map((item, index) => {
          item.title = item.name;
          if (index === 0) {
            this.centerTabsValue = item.name;
            this.centerTabsId = item.id;
            this.centerTabsEnergyType = item.energyType;
            this.getCenterPanelData(item.id, item.energyType);
          }
          return item;
        });
      } else {
        console.log("获取生活热水列表失败");
      }
    },
    //获取中间模块数据
    async getCenterPanelData(assetId, energyType) {
      this.loadingCenterData = true;
      this.loadingCC = true;
      const q3 = this.getHeatStorageWaterTankList(assetId);
      const q5 = this.getEnvironmentalMonitoring(assetId);
      const q7 = this.getBoilerEnergyEfficiency(assetId, "DAY");
      const q8 = this.getWarmWaterPumpList(assetId);
      const queryType = energyType || this.centerTabsEnergyType;
      if (queryType === "ac") {
        //空气源热泵
        const q6 = this.getAirSourceHeatPumpList(assetId);
        await Promise.all([q3, q5, q6, q7, q8]).catch((err) => {
          console.log("---getCenterPanelData---err----", err);
        });
      } else {
        //电制热，燃气制热
        const q9 = this.getObtainBoilerList(assetId);
        await Promise.all([q3, q5, q7, q8, q9]).catch((err) => {
          console.log("---getCenterPanelData---err----", err);
        });
      }

      this.loadingCenterData = false;
      this.loadingCC = false;
      this.updateTime = dateFtt("yyyy-MM-dd hh:mm:ss", new Date());
    },
    dealCenterPanelData(
      data = {},
      hasTitle = false,
      hasContent = false,
      mainElementIsArray = false,
      contentSwitchType = "default",
      combineNameUnit = true
    ) {
      const { on = 0, off = 0, children = [], main = [] } = data;
      const dataObj = {
        contentSwitch: [],
      };
      if (hasTitle) {
        dataObj.title = [
          {
            name: "运行中",
            value: on,
            colorValue: "#28CCCB",
          },
          {
            name: "已关闭",
            value: off,
          },
        ];
      }
      if (contentSwitchType == "coolingTower") {
        Array.isArray(children) &&
          children.forEach((element) => {
            const childObj = {
              name: "主机",
              state: "",
              value: "",
              description: "",
            };
            Array.isArray(element) &&
              element.forEach((item) => {
                if (item.name == "name") {
                  childObj.name = item.value;
                } else if (item.name != "id") {
                  if (item.name === "状态") {
                    childObj.state = matchingStatus(item.value);
                  } else {
                    childObj.value = dealNumWith(item.value, 1, "-");
                    childObj.description = item.unit
                      ? `${item.name}(${item.unit})`
                      : item.name;
                  }
                }
              });
            dataObj.contentSwitch.push(childObj);
          });
      } else if (
        ["obtainBoiler", "waterPumpCollector"].includes(contentSwitchType)
      ) {
        Array.isArray(children) &&
          children.forEach((element) => {
            const childObj = {
              name: "主机",
              state: "",
              value: [],
            };
            Array.isArray(element) &&
              element.forEach((item) => {
                if (item.name == "name") {
                  childObj.name = item.value;
                } else if (item.name != "id") {
                  if (item.name === "状态") {
                    if (contentSwitchType == "waterPumpCollector") {
                      childObj.state = matchingStatus(item.value);
                    } else {
                      if (item.value == -1) {
                        childObj.state =
                          "obtainBoiler" === contentSwitchType
                            ? "火力关闭"
                            : "已关闭";
                      } else {
                        childObj.state = "运行中";
                        if (this.centerTabsEnergyType !== "ac") {
                          item.value = matchingFireStatus(item.value);
                          item.name = "火力";
                          childObj.value.push(item);
                        }
                      }
                    }
                  } else {
                    item.value = dealNumWith(item.value, 1, "-");
                    if (item?.unit && combineNameUnit) {
                      item.name = `${item.name}(${item.unit})`;
                      item.unit = null;
                    }
                    childObj.value.push(item);
                  }
                }
              });
            dataObj.contentSwitch.push(childObj);
          });
      } else {
        Array.isArray(children) &&
          children.forEach((element) => {
            const childObj = {
              name: "主机",
              value: [],
            };
            Array.isArray(element) &&
              element.forEach((item) => {
                if (item.name == "name") {
                  childObj.name = item.value;
                } else if (item.name != "id") {
                  if (item.name === "状态") {
                    item.value = matchingStatus(item.value);
                    item.colorValue =
                      matchingStatus(item.value) == "运行中" ? "#28CCCB" : null;
                    item.fontSize = "14px";
                  } else {
                    item.value = dealNumWith(item.value, 1, "-");
                    if (item?.unit && combineNameUnit) {
                      item.name = `${item.name}(${item.unit})`;
                      item.unit = null;
                    }
                  }
                  childObj.value.push(item);
                }
              });
            dataObj.contentSwitch.push(childObj);
          });
      }
      if (hasContent) {
        if (mainElementIsArray) {
          Array.isArray(main) &&
            main.forEach((element) => {
              dataObj.content = [];
              Array.isArray(element) &&
                element.forEach((item) => {
                  if (item.name == "name") {
                    item.name = item.value;
                  } else if (item.name != "id") {
                    item.value =
                      item.name === "状态"
                        ? matchingStatus(item.value)
                        : dealNumWith(item.value, 1, "-");
                    dataObj.content.push(item);
                  }
                });
            });
        } else {
          dataObj.content = [];
          Array.isArray(main) &&
            main.forEach((item) => {
              if (item.name == "name") {
                item.name = item.value;
              } else if (item.name != "id") {
                item.value =
                  item.name === "状态"
                    ? matchingStatus(item.value)
                    : dealNumWith(item.value, 1, "-");
                dataObj.content.push(item);
              }
            });
        }
      }
      return dataObj;
    },
    //获取暖水泵
    async getWarmWaterPumpList(assetId) {
      let res = await api.DHWGetWarmWaterPumpList({
        projectId: getProjectVal("Id"),
        deviceTypes: "生活热水循环泵,锅炉热水循环泵",
        assetId: assetId || this.centerTabsId,
      });
      if (res && res.data.code == 200) {
        this.centerPanelData.warmWater = this.dealCenterPanelData(
          res.data.data,
          true,
          false,
          false,
          "waterPumpCollector"
        );
      } else {
        console.log("获取暖水泵失败");
      }
    },
    //获取锅炉机组
    async getObtainBoilerList(assetId) {
      let res = await api.DHWGetObtainBoilerList({
        projectId: getProjectVal("Id"),
        deviceType: "锅炉",
        assetId: assetId || this.centerTabsId,
        energyType: this.centerTabsEnergyType,
      });
      if (res && res.data.code == 200) {
        const newData = this.dealCenterPanelData(
          res.data.data,
          true,
          false,
          false,
          "obtainBoiler"
        );
        this.centerPanelData.obtainBoilerList = newData;
      } else {
        console.log("获取锅炉机组失败");
      }
    },
    //获取空气源热泵列表
    async getAirSourceHeatPumpList(assetId) {
      let res = await api.DHWGetAirSourceHeatPumpList({
        projectId: getProjectVal("Id"),
        deviceType: "空气源热泵",
        assetId: assetId || this.centerTabsId,
      });
      if (res && res.data.code == 200) {
        const newData = this.dealCenterPanelData(
          res.data.data,
          true,
          false,
          false,
          "obtainBoiler"
        );
        this.centerPanelData.obtainBoilerList = newData;
      } else {
        console.log("获取空气源热泵列表失败");
      }
    },
    //获取保温水箱列表
    async getHeatStorageWaterTankList(assetId) {
      let res = await api.DHWGetHeatStorageWaterTankList({
        projectId: getProjectVal("Id"),
        assetId: assetId || this.centerTabsId,
        deviceType: "储热水箱",
      });
      if (res && res.data.code == 200) {
        const newData = this.dealCenterPanelData(
          { children: res.data.data },
          false,
          false,
          true,
          false,
          false
        );
        this.centerPanelData.waterTank = newData;
      } else {
        console.log("获取保温水箱列表失败");
      }
    },
    //环境监测
    async getEnvironmentalMonitoring(assetId) {
      let res = await api.ACRGetEnvironmentalMonitoring({
        projectId: getProjectVal("Id"),
        assetId: assetId || this.centerTabsId,
        modular: "环境监测",
      });
      if (res && res.data.code == 200) {
        const { newData } = this.dealNameWithAll(res.data.data);
        this.centerPanelData.envMonitorData = newData;
      } else {
        console.log("获取生活热水概览失败");
      }
    },
    //锅炉能效
    async getBoilerEnergyEfficiency(assetId, dateType) {
      let res = await api.DHWGetBoilerEnergyEfficiency({
        projectId: getProjectVal("Id"),
        assetId: assetId || this.centerTabsId,
        deviceTypes: "锅炉,空气源热泵",
        dateType,
      });
      if (res && res.data.code == 200) {
        const topNode = [];
        const bottomNode = res.data.data.filter((item) => {
          if (["用气", "用水", "用电"].includes(item.name)) {
            topNode.push(item);
            return false;
          }
          return true;
        });
        this.centerPanelData.boilerEnergyData = {
          topNode,
          bottomNode,
        };
      } else {
        console.log("获取锅炉能效失败");
      }
    },
    changeCenter(tab) {
      const newId = this.centerTabs[tab.index].id;
      const newEnergyType = this.centerTabs[tab.index].energyType;
      this.centerTabsId = newId;
      this.centerTabsEnergyType = newEnergyType;
      this.getCenterPanelData(newId, newEnergyType);
    },
  },
  created() {
    this.getAlarmsList();
    this.getWorkOrderList();
    this.getDomesticHotHaterList();
  },
  mounted() {
    this.$bus.$on("getBoilerEnergyEfficiency", (assetId, dateType) => {
      this.getBoilerEnergyEfficiency(assetId, dateType);
    });
  },
  beforeDestroy() {
    this.$bus.$off("getBoilerEnergyEfficiency");
  },
};
</script>

<style lang="scss" scoped>
$borderRadius: 5px;

.DHWSystemWrap {
  width: 100%;
  overflow: auto;
  padding: 16px 0;
  min-width: 1600px;

  .center {
    height: 990px;
    // margin: 20px auto;
    // width: 96%;
    width: calc(100% - 32px);
    margin: 0 12px 16px;
  }

  .bottom {
    width: calc(100% - 32px);
    margin: 0 16px;
    // width: 96%;
    // margin: 0 auto;
    height: 500px;
    @include setFlexBetween;

    & > div {
      width: 49.5%;
      height: 100%;
    }
  }
}
</style>
